import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DashboardDataTable from 'modules/common/dashboardDataTable.component';
import PropTypes from 'prop-types';
import React from 'react';

// Simple date formatter
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');
  } catch {
    return 'N/A';
  }
};

const useStyles = makeStyles((theme) => ({
  noData: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
}));

const CoveragePeriodsGrid = ({ periods, isLoading, rcColumnHeader }) => {
  const classes = useStyles();

  const columns = [
    { accessorKey: 'rcName', header: rcColumnHeader },
    { accessorKey: 'coveringUserName', header: 'Covering User' },
    { accessorKey: 'fileCount', header: '# of Files' },
    {
      accessorKey: 'startDate',
      header: 'Start Date',
      Cell: ({ cell }) => (cell.getValue() ? formatDate(cell.getValue()) : 'N/A'),
    },
    {
      accessorKey: 'endDate',
      header: 'End Date',
      Cell: ({ cell }) => (cell.getValue() ? formatDate(cell.getValue()) : 'N/A'),
    },
  ];

  if (isLoading) {
    return (
      <Typography className={classes.noData} color="textSecondary">
        Loading coverage periods...
      </Typography>
    );
  }

  if (periods.length === 0) {
    return (
      <Typography className={classes.noData} color="textSecondary">
        No coverage periods found.
      </Typography>
    );
  }

  return (
    <DashboardDataTable
      columns={columns}
      data={periods}
      initialSorting={[{ id: 'startDate', desc: false }]}
    />
  );
};

CoveragePeriodsGrid.propTypes = {
  periods: PropTypes.arrayOf(
    PropTypes.shape({
      coverageId: PropTypes.number.isRequired,
      rcName: PropTypes.string.isRequired,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      fileCount: PropTypes.number,
      coveringUserName: PropTypes.string,
      coveringRole: PropTypes.string,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  rcColumnHeader: PropTypes.string,
};

CoveragePeriodsGrid.defaultProps = {
  rcColumnHeader: 'RC',
};

export default CoveragePeriodsGrid;
